<template>
  <div class="sale-info">
    <div class="flexbox gap-5">
      <div class="tag" :class="{'has-entry': sale.hasEntry}">{{ getEntryStatus(sale) }}</div>
      <div v-if="sale.recommend" class="tag recommend">おすすめ</div>
    </div>
    <div class="tag mall" :style="{ backgroundColor: sale.mall.color, borderColor: sale.mall.color }">{{ sale.mall.name }}</div>
    <img class="sale-banner" :src="sale.bannerUrl">
    <div class="flexbox gap-5">
      <div class="tag" :class="{'premium': sale.categoryName === 'プレミアム'}">{{ sale.categoryName}}</div>
      <div class="tag" :class="{ 'deadline': calcDeadline(sale.applicationPeriodTo) <= 3}">{{ `締切まで${calcDeadline(sale.applicationPeriodTo)}日` }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/ja'

export default {
  props: {
    sale: {
      type: Object
    },
    isEntry: {
      type: Boolean,
      default: false
    }
  },
  created () {
    moment.locale('ja')
  },
  methods: {
    getEntryStatus (sale) {
      if (sale.hasEntry) {
        return 'エントリー済み'
      }

      return '未エントリー'
    },
    calcDeadline (applicationPeriodTo) {
      const endDate = moment(applicationPeriodTo)
      const now = moment()
      const diffDays = endDate.diff(now, 'days')
      const diffMinutes = endDate.diff(now, 'minutes')
      if (endDate.isBefore(now)) return 0
      return diffMinutes > 0 ? diffDays + 1 : diffDays
    }
  }
}
</script>
<style scoped>
.text-gray {
  color: #666;
}
.sale-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.tag {
  flex: 0.5;
  border: 1px solid #ccc;
  text-align: center;
  padding: 5px;
  font-weight: bold;
  background-color: #fff;
}
.sale-banner {
  width: 100%;
  object-fit: fill;
}
.recommend {
  background-color: red;
  color: #fff;
  border-color: red;
}
.has-entry {
  background-color: #aaa;
  color: #fff;
}
.mall {
  color: #fff;
}
.premium {
  border-color: #bf9000;
  color: #bf9000;
}
.deadline {
  color: red;
  border-color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleInfo.vue